var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditorContainer',[_c('ModuleHeader',{attrs:{"title":_vm.$t('location.title'),"is-active":""}}),_c('v-expansion-panel-content',[(_vm.buffer)?_c('div',[_c('div',{staticClass:"flex items-center"})]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }